import { useSnackbar } from 'notistack';
import { Dispatch, SetStateAction } from 'react';
import { Box, Divider, Modal, styled } from '@mui/material';
import { QButton, QTypography } from '@kw/quokka-ui';
import { sendHttpRequest } from '../../../utils/network.service';

export const RemoveDeniedAppConfirmationModal = ({
  showConfirmationModal,
  setShowConfirmationModal,
  selectedApp,
  fetchDeniedApps,
}: IProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleRemoveDeniedApp = async (applicationId: string, os: string, name: string, vendorName: string) => {
    await sendHttpRequest({
      path: `${process.env.LIST_SERVICE_URL}/list/denied-apps/${applicationId}/${os}`,
      method: 'DELETE',
      successMessage: `Successfully removed ${name} from Denied Apps`,
      errorMessage: `Error removing ${name} from Denied Apps`,
      enqueueSnackbar,
    });

    fetchDeniedApps();
  };

  return (
    <Modal
      open={showConfirmationModal}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
      onClose={() => setShowConfirmationModal(false)}
      onClick={e => e.stopPropagation()}
    >
      <StyledBox>
        <QTypography variant="h3Medium" id="confirmation-modal-title">
          Remove from Denied Apps?
        </QTypography>

        <StyledDivider />

        <div id="confirmation-modal-description">
          <QTypography variant="bodyRegular">{selectedApp.name} will be removed from your Denied Apps list.</QTypography>
        </div>

        <StyledButtonsContainer>
          <QButton onClick={() => setShowConfirmationModal(false)}>Cancel</QButton>
          <QButton
            variant="filled"
            onClick={() => {
              handleRemoveDeniedApp(selectedApp.applicationId, selectedApp.os, selectedApp.name, selectedApp.vendorName);
              setShowConfirmationModal(false);
            }}
          >
            Remove from Denied Apps
          </QButton>
        </StyledButtonsContainer>
      </StyledBox>
    </Modal>
  );
};

interface IProps {
  showConfirmationModal: boolean;
  setShowConfirmationModal: Dispatch<SetStateAction<boolean>>;
  selectedApp: { applicationId: string; os: string; name: string; vendorName: string };
  fetchDeniedApps: () => void;
}

const StyledBox = styled(Box)(() => ({
  padding: 16,
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 540,
  backgroundColor: '#fafafa',
}));

const StyledDivider = styled(Divider)({
  marginTop: 8,
  marginBottom: 8,
});

const StyledButtonsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: 8,
});
